module.exports = "<p>menu-expediente-clinico-movil works!</p>\n"